/*
*   Данные и логика по промокодам
*/
import router from '@/router/index';
import ajaxRequest from '@/utils/request';

const state = {
    loaded: true,
    promocodes: []
};

const getters = {
    promocodes: state => state.promocodes
};

const actions = {
    loadPromocodes(context) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/cost_rules/promocode/get/',
                success(response) {
                    context.commit('loadPromocodes', response.data);
                    resolve();
                },
                failure({errorMessage}) {
                    reject(errorMessage);
                }
            });
        });
    },
    savePromocode(context, promocode) {
        ajaxRequest({
            url: '/cost_rules/promocode/save/',
            method: 'POST',
            params: promocode,
            success(response) {
                context.commit('savePromocode', {
                    created: response.created,
                    data: response.data
                });
            }
        });
    },
    deletePromocode(context, promocode) {
        ajaxRequest({
            url: '/cost_rules/promocode/delete/',
            method: 'POST',
            params: promocode,
            success(response) {
                context.commit('deletePromocode', promocode);
            }
        });
    }
};

const mutations = {
    loadPromocodes(state, data) {
        state.loaded = true;
        state.promocodes = data;
    },
    savePromocode(state, {created, data}) {
        if (!created) {
            let old = state.promocodes.findIndex(item => item.id === data.id);
            state.promocodes.splice(old, 1);
        }
        let index = state.promocodes.findIndex(item => item.promocode > data.promocode);
        state.promocodes.splice(index, 0, data);

        this.commit('changeEditedPromocode', data);
        router.push({name: 'Promocodes'});
    },
    deletePromocode(state, promocode) {
        let old = state.promocodes.findIndex(item => item.id === promocode.id);
        state.promocodes.splice(old, 1);

        this.commit('changeEditedPromocode', {...promocode, id: null});
        router.push({name: 'Promocodes'});
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/promocodes.js